module.exports = __webpack_public_path__ + "static/media/quimicosLogo.6fcd5847.png";